import { debugWarn } from '@vuesax-plus/utils'
import { useAttrs } from '@vuesax-plus/hooks'
import { computed, getCurrentInstance } from 'vue'
import { componentColors } from '@vuesax-plus/constants'
import { getVsColor } from '@vuesax-plus/utils'

export const getComponentColor = () => {
  const instance = getCurrentInstance()
  if (!instance) {
    debugWarn(
      'use-attrs',
      'getCurrentInstance() returned null. getComponentColor() must be called at the top of a setup function'
    )
    return computed(() => null)
  }

  const attrs = useAttrs({ excludeListeners: true })

  return computed(() => {
    let propColor = componentColors.find((color) => attrs.value[color] === true)
    if (propColor) return propColor

    const hasColorString = attrs.value['color'] as string | undefined
    if (!hasColorString) return null

    return getVsColor(hasColorString)
  })
}
